import { createAction, props } from '@ngrx/store';
import { MenuIconData, MenuItem, MenuItemType } from '../domain/menu-item';
import { ProfileType } from './components/menu-editor-screen/menu-editor-screen.view-model';

const featureKey = '[Menu editor]';

export const loadCxbMenuEditorPage = createAction(`${featureKey} Load page`, props<{ platform: string; profileType: ProfileType }>());

export const loadCxbMenuEditorPageSuccess = createAction(`${featureKey} Load page success`, props<{ platforms: Record<string, string> }>());

export const loadCxbMenuEditorPageFail = createAction(`${featureKey} Load page fail`, props<{ errorMessage: string }>());

export const reloadCxbMenuEditorPage = createAction(`${featureKey} Reload page`);

export const loadCxbMenuEditorPageWithPlatform = createAction(
  `${featureKey} Load page with platform`,
  props<{ platformId: string; platforms: Record<string, string>; profileType: ProfileType }>()
);

export const loadCxbMenuEditorPageWithPlatformSuccess = createAction(
  `${featureKey} Load page with platform success`,
  props<{ menuItems: MenuItem[] }>()
);

export const loadCxbMenuEditorPageWithPlatformFail = createAction(
  `${featureKey} Load page with platform fail`,
  props<{ errorMessage: string }>()
);

export const changeCxbMenuItemVisibility = createAction(
  `${featureKey} Change menu item visibility`,
  props<{ pageId: string; menuId: string; visible: boolean }>()
);

export const changeCxbMenuItemVisibilityFail = createAction(`${featureKey} Change menu item visibility fail`);

export const changeCxbMenuItemsOrder = createAction(
  `${featureKey} Change menu items order`,
  props<{ movement: { from: number; to: number } }>()
);

export const changeCxbMenuItemsOrderFail = createAction(`${featureKey} Change menu items order fail`);

export const publishCxbMenuEditorPage = createAction(`${featureKey} Publish page`);

export const publishCxbMenuEditorPageSuccess = createAction(`${featureKey} Publish page success`);

export const publishCxbMenuEditorPageFail = createAction(`${featureKey} Publish page fail`, props<{ errorMessage: string }>());

export const saveIconsCxbMenuEditorPage = createAction(
  `${featureKey} Save icons`,
  props<{
    pageId: string;
    icons: { focused: MenuIconData; normal: MenuIconData; highlighted: MenuIconData; selected: MenuIconData };
    profile: string;
  }>()
);

export const changeCxbMenuItemType = createAction(
  `${featureKey} Change menu item type`,
  props<{ pageId: string; menuItemType: MenuItemType }>()
);
